const langList = [
    { label: 'English', value: 'en' },
    { label: 'Русский', value: 'ru' },
    { label: "O'zbek tili", value: 'uz' },
];

export default langList;
